import '../css/page-footer.css';
import '../css/icons.css';
import { ReactComponent as PhoneIcon } from '../images/phone.svg';
import { ReactComponent as LetterIcon } from '../images/email.svg';
import { ReactComponent as ForumIcon } from '../images/forum.svg';
import iconIg from '../images/instagram.svg';
import iconFb from '../images/facebook.svg';
import iconTw from '../images/twitter.svg';
import iconYt from '../images/youtube.svg';

function PageFooter() {
  const today = new Date();
  const year = today.getFullYear();

  return (
    <footer className="page-footer">
      <div className="page-footer__section page-footer__section--top">
        <div className="page-footer__section-container container">
          <div className="contact-item">
            <div className="contact-item__title">MND Connect helpline</div>
            <div className="contact-item__actions">
              <div className="footer-icon"><PhoneIcon className="icon"/><a href="tel:08088026262">0808 802 6262</a></div>
              <div className="footer-icon"><LetterIcon className="icon"/><a href="mailto:mndconnect@mndassociation.org">Email us</a></div>
              <div className="footer-icon"><ForumIcon className="icon"/><a href="https://forum.mndassociation.org/">Visit the forum</a></div>
            </div>
          </div>
          <div className="contact-item">
            <div className="contact-item__title">Fundraising enquiries</div>
            <div className="contact-item__actions">
              <div className="footer-icon"><PhoneIcon className="icon"/><a href="tel:01604611860">01604 611860</a></div>
              <div className="footer-icon"><LetterIcon className="icon"/><a href="mailto:fundraising@mndassociation.org">Email us</a></div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-footer__section page-footer__section--center">
        <div className="page-footer__section-container container">
          <div className="page-footer__logo-group">
            <div className="page-footer__partner">
              <a href="https://www.fundraisingregulator.org.uk/validate?registrant=MOTOR+NEURONE+DISEASE+ASSOCIATION+%28MNDA%29" class="fr-digital-badge">
                <img src="https://www.fundraisingregulator.org.uk/fr-badge/e26db16a-6182-4260-80c0-56d091c613e9/en/colour" width="100%" alt="Fundraising Regulator badge with validation link" loading="lazy" />
                </a>
            </div>
            <div className="page-footer__social">
              <div className="social-item social-item--ig"><a href="https://www.instagram.com/mndassoc/"><img src={iconIg} className="page-footer__social-icon" alt="Instagram logo" /></a></div>
              <div className="social-item social-item--fb"><a href="https://www.facebook.com/mndassociation/"><img src={iconFb} className="page-footer__social-icon" alt="Facebook logo" /></a></div>
              <div className="social-item social-item--tw"><a href="https://x.com/mndassoc"><img src={iconTw} className="page-footer__social-icon" alt="X (previously Twitter) logo" /></a></div>
              <div className="social-item social-item--yt"><a href="https://www.youtube.com/mndassociationofficial"><img src={iconYt} className="page-footer__social-icon" alt="You Tube logo" /></a></div>
            </div>
          </div>
          <div className="page-footer__menu-group">
            <ul className="menu">
              <li><a href="https://shop.mndassociation.org/">Shop</a></li>
              <li><a href="https://mnda.raffleentry.org.uk/">Raffle</a></li>
              <li><a href="https://jobs.mndassociation.org">Jobs</a></li>
            </ul>
            <ul className="menu">
              <li><a href="https://i.emlfiles4.com/cmpdoc/9/6/7/7/8/1/files/71755_privacypolicy.pdf">Privacy Policy</a></li>
              <li><a href="https://i.emlfiles4.com/cmpdoc/9/6/7/7/8/1/files/71767_termsandconditions.pdf">Terms and Conditions</a></li>
              <li><a href="https://i.emlfiles4.com/cmpdoc/9/6/7/7/8/1/files/71766_cookiepolicy.pdf">Cookie Policy</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="page-footer__section page-footer__section--bottom">
        <div className="page-footer__section-container container">
          <p>&nbsp;<strong>© {year} MND Association</strong>: Registered in England at <strong>Francis Crick House, 6 Summerhouse Road, Moulton Park, Northampton, NN3 6BJ</strong>. <strong>Registered Charity no. 294354</strong>. VAT Registration no. 316 4340 28.</p>
        </div>
      </div>
    </footer>
  );
}

export default PageFooter;
